/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-09-17 11:32:30
 * @LastEditors: linxi
 * @LastEditTime: 2023-07-04 14:35:57
 */
import { Button, Col, notification, Space } from 'antd'
import React, {
  ReactElement,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { TabBar, TabPane } from '../../compnents/widgets/TabBar'
import { selectTwoMenus,selectMenus } from '../../layouts/layoutSlice'
import { ThemeContext } from '../../theme/ThemeContext'
import { MembersManagementPage } from '../membersManagement/membersManagementPage'
import { OutPatientList } from '../outpatientList/outpatientList'
import { Patients, PatientsRef } from '../patient/list/Patients'
import { PatientLable } from '../patient/patientLable/patientlable'
import { ExportOutlined } from '../../compnents/icons/Icons'
import { selectRole } from '../../app/applicationSlice'
import styles from './OutpatientStatistics.module.css'
import { selectExportloading } from '../patient/list/patientListSlice'

export const OutpatientStatistics = (): ReactElement => {
  const theme = useContext(ThemeContext)
  
  const role = useSelector(selectRole)

  const exportRef = useRef<PatientsRef>(null)

  const exRef = useRef<any>(null)

  const location: any = useLocation()

  const [selectedTab, setSelectedTab] = useState('0')

  const storageParams = JSON.parse(
    sessionStorage.getItem(location.pathname) || '{}'
  )

  useEffect(() => {
    setSelectedTab(location?.state?.station || storageParams.state || '0')
  }, [location?.state])

 const exportLoading = useSelector(selectExportloading)

 const twoMenus = useSelector(selectTwoMenus)


  const menuList = twoMenus?.filter((v) => {
    return v?.name == '患者管理'
  })?.[0]


  const getKeys = (i: string) => {
    switch (i) {
      case '患者管理':
        return '0'
      case '患者标签管理':
        return '1'
      case '会员管理':
        return '2'
      case '门诊日志':
        return '3'
      default:
        return '-'
    }
  }

  return (
    <Col
      style={{
        display: 'flex',
        position: 'relative',
        flexDirection: 'column',
        height: '100%',
        overflowY: 'hidden',
      }}
    >
      <TabBar
        style={{ margin: '10px 20px' }}
        activeKey={selectedTab}
        destroyInactiveTabPane
        onChange={(v) => setSelectedTab(v)}
      >
        {menuList?.subMenus?.map((v: any) => {
          return (
            <>
              <TabPane key={getKeys(v?.name)} tab={v?.name}>
                {v?.name == '患者管理' ? (
                  <Patients state={selectedTab} ref={exportRef}/>
                ) : v?.name == '患者标签管理' ? (
                  <PatientLable state={selectedTab} />
                ) : v?.name == '会员管理' ? (
                  <MembersManagementPage state={selectedTab} />
                ) : v?.name == '门诊日志' ? (
                  <Col
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      backgroundColor: theme.pn,
                      borderRadius: 10,
                      margin: '10px 0',
                      height: 'calc(100% - 10px)',
                    }}
                  >
                    <Col
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        backgroundColor: theme.pn,
                        borderRadius: 10,
                        margin: '10px 0',
                        height: 'calc(100% - 10px)',
                      }}
                    >
                      <OutPatientList ref={exRef} parentId={v?.id} />
                    </Col>
                  </Col>
                )  : (
                  <></>
                )}
              </TabPane>
            </>
          )
        })}
      </TabBar>
      {selectedTab == '0' ? (
        <Space
          style={{
            position: 'absolute',
            top: '14px',
            right: '30px',
          }}
        >
          <Button
            type='text'
            loading={exportLoading}
            className={styles.exportBtn}
            onClick={() => {
              if (role == 1) {
                exportRef?.current?.outClude()
              } else {
                notification.info({
                  message: '非管理员不支持导出，请联系管理员导出',
                })
              }
            }}
          >
            <ExportOutlined
              className={styles.exportIcon}
            />
            导出
          </Button>
        </Space>
      ) : (
        <></>
      )}
    </Col>
  )
}
